import { Injectable } from '@angular/core';
import { NotificationService } from './NotificationService';

@Injectable({
    providedIn: 'root'
})
export class NotificationTransitionsService {
    public initialize(notificationService: NotificationService) {
        // base implementation does nothing
        // 'provide' an alternate implementation in your
        // @NgModule to set up cancelling based on your router implementation
        // see UiRouterNotificationTransitionsService in this folder
    }
}
